// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"198":"12260016","279":"a6f40b67","316":"5e7afb02","355":"9c69d7ed","715":"14ed4fd9","825":"65e2a4a0"}[chunkId] + ".css";
};